import store from '@/store';
import { UserState } from '@/store/types';

/**
 * Adds a list of code ids to the list of recent code ids stored in the user store local config
 */
export const updateRecentCodes = (projectId: string, codeIds: Array<string>) => {
  const localConfig: UserState['localConfig'] = store.getters['user/localConfig'];

  const projects = localConfig.projects || {};

  const recentCodeIds = projects[projectId]?.recentCodeIds || [];

  codeIds.forEach((id) => {
    recentCodeIds.push(id);
  });

  // reverse the array, so that added codes that were already in the recent list,
  // update their position after removing duplicates with Set()
  // (Set uses the first match)
  recentCodeIds.reverse();

  const unique = [...new Set(recentCodeIds).values()].reverse();
  const limited = unique.slice(unique.length - 50);

  store.dispatch('user/setLocalConfig', {
    [`projects.${projectId}.recentCodeIds`]: limited,
  });
};
